import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import Layout from "./components/Layout";
import { AuthProvider, CartProvider } from "./lib/ctx";
import Home from "./pages/Home";
import { ShopPage, ProductDetail, Basket } from "./pages/Shop";
import { Checkout, PaymentSuccess } from "./pages/Checkout";
import { Login, Register, Account, OrderTracking, About, Contact, DeliveryPage, Offers, ReviewsPage, FAQ, Privacy, Terms, Returns, DeliveryPolicy, Cookies } from "./pages/Pages";
import ComingSoon from "./pages/ComingSoon";
import Consultation from "./pages/Consultation";
import AdminApp from "./pages/Admin";

export default function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <AuthProvider>
          <CartProvider>
            <Layout>
            <Routes>
              <Route path="/" element={<Home/>}/>
              <Route path="/shop" element={<ShopPage/>}/>
              <Route path="/honey" element={<ShopPage category="honey"/>}/>
              <Route path="/supplements" element={<ShopPage category="supplements"/>}/>
              <Route path="/herbal" element={<ShopPage category="herbal"/>}/>
              <Route path="/product/:slug" element={<ProductDetail/>}/>
              <Route path="/basket" element={<Basket/>}/>
              <Route path="/checkout" element={<Checkout/>}/>
              <Route path="/payment/success" element={<PaymentSuccess/>}/>
              <Route path="/offers" element={<Offers/>}/>
              <Route path="/coming-soon" element={<ComingSoon/>}/>
              <Route path="/consultation" element={<Consultation/>}/>
              <Route path="/ruqyah" element={<Consultation/>}/>
              <Route path="/about" element={<About/>}/>
              <Route path="/contact" element={<Contact/>}/>
              <Route path="/delivery" element={<DeliveryPage/>}/>
              <Route path="/reviews" element={<ReviewsPage/>}/>
              <Route path="/track" element={<OrderTracking/>}/>
              <Route path="/staff-login" element={<Login/>}/>
              <Route path="/login" element={<Login/>}/>
              <Route path="/register" element={<Register/>}/>
              <Route path="/account" element={<Account/>}/>
              <Route path="/faq" element={<FAQ/>}/>
              <Route path="/privacy" element={<Privacy/>}/>
              <Route path="/terms" element={<Terms/>}/>
              <Route path="/returns" element={<Returns/>}/>
              <Route path="/delivery-policy" element={<DeliveryPolicy/>}/>
              <Route path="/cookies" element={<Cookies/>}/>
              <Route path="/admin/*" element={<AdminApp/>}/>
            </Routes>
          </Layout>
          <Toaster theme="dark" position="top-right" richColors/>
          </CartProvider>
        </AuthProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
}
